import React, { useState, useEffect } from 'react';
import { getCsrfHeader } from './csrf';

export default function TransactionRow(props) {
    const [selectClass, setSelectClass] = useState('');
    const [transaction, setTransaction] = useState(props.transaction);
    const [category, setCategory] = useState(props.transaction.category);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [suggestions, setSuggestions] = useState([]);

    const updateCategoryFromDropdown = (e, transaction) => {
        setSelectClass('loading');
        const newCategory = e.target.value;
        setCategory(newCategory);
		setSuggestions([]);
        updateCategory({ ...transaction, category: newCategory });
    };


    const updateCategoryFromButton = (suggestion, tx) => {
        setCategory(suggestion);
		setSuggestions([]);
        updateCategory({ ...tx, category: suggestion });
    };

    const updateCategory = (tx) => {
        console.log('PUTTING TRANSACTION:', tx);

        fetch('/transactions', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...getCsrfHeader() },
            body: JSON.stringify(tx)
        }).then((response) => {
            console.log('PUT TO /transactions RETURNED:', response);

            if (response.ok) {
                setTransaction(tx);  // ✅ Update transaction after a successful response
                setCategory(tx.category);  // ✅ Sync category with transaction update
                setShowSuggestions(false); // ✅ Ensure suggestions are hidden
            } else {
				console.log('RESPONSE', response);
			}
        }).catch((error) => {
            console.log('PUT request failed:', error);
        }).finally(() => {
            setSelectClass('');
        });
    };

    const suggestionsUrl = "/transactions/categories/suggested";

    async function fetchSuggestions(tx) {
        if (tx.category != null && tx.category.trim() !== '') {
            return [];
        }
        try {
            let response = await fetch(suggestionsUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', ...getCsrfHeader() },
                body: JSON.stringify(tx)
            });
            let json = await response.json();
            return json;
        } catch (error) {
            console.log('ERROR!', error);
            return [];
        }
    }

    useEffect(() => {
        console.log('FETCHING SUGGESTIONS...');
        fetchSuggestions(transaction).then(json => {
            if (!(json) || json.length === 0) {
                return;
            }
            console.log('SETTING SUGGESTIONS:', json);
            setSuggestions(json);
            setShowSuggestions(true);
        }).catch(error => {
            console.log('error occurred in fetchData:', error);
        });
    }, []);

    useEffect(() => {
        if (category && category.trim() !== '') {
            console.log("Category updated, hiding suggestions...");
            setShowSuggestions(false);
        }
    }, [category]); // ✅ Runs whenever category updates

    return (
        <tr>
            <td>
                {transaction.checkImage ? (
                    <img src={`/checks/image/${transaction.checkImage.id}`} alt="Check Image" />
                ) : transaction.isCheck ? (
                    <>
                        <img src="/images/checkbook-icon.png" alt="Checkbook Icon" className="check-icon" />
                        <span style={{ fontSize: '12px', marginLeft: '5px' }}>Check</span>
                    </>
                ) : null}
            </td>

            <td>{transaction.date.substring(0, 4) + '/' + transaction.date.substring(5, 7) + '/' + transaction.date.substring(8, 10)}</td>
            <td>{transaction.description}</td>
            <td className="amount" style={transaction.amount < 0 ? { color: '#C0392B' } : { fontWeight: 500 }}>{transaction.amount}</td>
            <td className={selectClass}>
                <select key={props.index} value={category} onChange={(e) => updateCategoryFromDropdown(e, transaction)}>
                    <option value=""></option>
                    {props.categories.map(cat => (
                        <option key={cat} value={cat}>{cat}</option>
                    ))}
                </select>
            </td>
            <td>
                <div className={showSuggestions ? "" : "hide"}>
                    {suggestions.map((suggestion, index) => (
                        <button key={index} onClick={() => updateCategoryFromButton(suggestion, transaction)}>
                            {suggestion}
                        </button>
                    ))}
                </div>
            </td>
        </tr>
    );
}
